<template>
  <section id="jobs" class="jobs" data-0="opacity:0;" data-center-top="opacity:1;">
    <div class="content">
      <div class="jobs-wrap">
        <span>Now Hiring!</span>
        <p>Join the &ldquo;We Know Trucks&rdquo; Team! <a href="mailto:hrdept@advantagetruckne.com">hrdept@advantagetruckne.com</a></p>
      </div>
    </div>
  </section>
</template>

<script>

  export default {
    name:'HomeJobs',
    data(){
      return {}
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/HomeJobs.vue